module.exports = "/assets/src/client/assets/topLevelPage/styled-Calendar.svg";